import { callApi } from "./api";

class OrdinationsAndCountriesServiceClass {
  async getCountries() {
    return await callApi({ url: "/api/countries?fields=id,name,img" });
  }
  async getOrdinations() {
    return await callApi({ url: "/api/ordinations/" });
  }
  async getSelectedOrdinationId() {
    try{
    const selectedOrdArr = await callApi({ url: "/api/ordination/get" });
    return selectedOrdArr[0].id;
    }catch{
      return 0;
    }
  }
  async selectOrdination(id) {
    return await callApi({ url: `/api/ordination/choose/${id}/` });
  }
}

export const OrdinationsAndCountriesService =
  new OrdinationsAndCountriesServiceClass();